import { NgModule } from '@angular/core';
import { FbqGgProductPageEventBuilder } from './fbq-gg-product-page-event.builder';

@NgModule({})
export class FbqGgProductPageEventModule {
  constructor(_FbqGgProductPageEventBuilder: FbqGgProductPageEventBuilder) {}
}
